import { CrossLargeIcon, MagicIcon } from '@fingertip/icons'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'

type Props = {
  open: boolean
  setOpen: (open: boolean) => void
  className?: string
  disabled?: boolean
  content: string | undefined
}

export const AskAiButton = ({
  setOpen,
  open,
  className,
  disabled,
  content = '',
}: Props) => {
  const { t } = useTranslation()

  return (
    <Button
      onClick={() => setOpen(!open)}
      type="button"
      size="xs"
      className={className}
      variant="magicSecondary"
      disabled={disabled}
    >
      {open ? (
        <CrossLargeIcon className="size-4 mr-1" />
      ) : (
        <MagicIcon className="size-4 mr-1" />
      )}

      {content.length > 0 ? t('edit_with_ai') : t('write_with_ai')}
    </Button>
  )
}
